import styled from 'styled-components';

export const PaymentProtectionsStyles = styled.div<{
  theme?: 'dark-violet' | 'domination' | 'dark-forest' | null;
}>`
  display: flex;
  align-items: center;
  justify-content: space-around;
  padding: 12px 20px;
  background: var(--protections-bg);
  border-radius: 12px;
  margin-bottom: 16px;

  ${({ theme }) =>
    theme === 'domination' &&
    `
      background: rgba(255, 255, 255, 0.05);
    `}

  ${({ theme }) =>
    theme === 'dark-forest' &&
    `
      background: rgba(255, 255, 255, 0.05);
    `}
`;

export const PaymentProtectionsDividerStyles = styled.div`
  width: 1px;
  height: 26px;
  background: var(--protections-item-divider-bg);
  margin: 0 12px;
`;

export const PaymentProtectionsItemStyles = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  color: var(--protections-item-color);
`;
